// extracted by mini-css-extract-plugin
module.exports = {"root":"telemetry-error_root__nDdok","inner":"telemetry-error_inner___f__2"};